var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1818 16.875C19.57 16.875 10.3636 19.1194 10.3636 23.625V27H38V23.625C38 19.1194 28.7936 16.875 24.1818 16.875ZM8.63636 10.125V5.0625H5.18182V10.125H0V13.5H5.18182V18.5625H8.63636V13.5H13.8182V10.125M24.1818 13.5C26.0142 13.5 27.7716 12.7888 29.0673 11.523C30.363 10.2571 31.0909 8.54021 31.0909 6.75C31.0909 4.95979 30.363 3.2429 29.0673 1.97703C27.7716 0.711158 26.0142 0 24.1818 0C22.3494 0 20.5921 0.711158 19.2964 1.97703C18.0006 3.2429 17.2727 4.95979 17.2727 6.75C17.2727 8.54021 18.0006 10.2571 19.2964 11.523C20.5921 12.7888 22.3494 13.5 24.1818 13.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add_user.2215c2a504c5e2c7ca52f2093fa617ca.svg";
export { ForwardRef as ReactComponent };